// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-cell {
  font-size: small;
  font-weight: bold;
  background: none;
  border-bottom: 1px solid #e0e0e0;
}`, "",{"version":3,"sources":["webpack://./projects/eCash/src/app/manage-request/requests-pending-my-action/requests-pending-my-action.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;AACJ","sourcesContent":[".group-cell {\n    font-size: small;\n    font-weight: bold;\n    background: none;\n    border-bottom: 1px solid #e0e0e0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
